import Logo from "@/assets/logo.svg";
import SymbolLogo from "@/assets/symbol-logo.svg";

import "./styles.scss";
import { MobileMenu } from "../mobile-menu";
import { useEffect, useRef, useState } from "react";
import { Button } from "../button";
import { useTracking } from "@/hooks/useTracking";

export const Header = () => {
  const { sendEvent } = useTracking()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isScrolledRef = useRef(isScrolled);

  useEffect(() => {
    isScrolledRef.current = isScrolled;
  }, [isScrolled]);

  useEffect(() => {
    const handleScroll = () => {
      updateScroll(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const updateScroll = (scrollY: number) => {
    if (scrollY === 0 && isScrolledRef.current) {
      setIsScrolled(false);
      return;
    }

    if (scrollY > 0 && !isScrolledRef.current) {
      setIsScrolled(true);
      return;
    }
  };

  const handleClickMobileMenu = () => {
    setIsMobileMenuOpen(true);

    sendEvent("button_clicked", {
      event_category: "header",
      event_label: "mobile_menu",
      event_action: "open",
      value: 1,
    });
  };

  const handleClosekMobileMenu = () => {
    setIsMobileMenuOpen(false);

    sendEvent("button_clicked", {
      event_category: "header",
      event_label: "mobile_menu",
      event_action: "close",
      value: 1,
    });
  };

  const handleClickItem = (item: string) => {
    sendEvent("button_clicked", {
      event_category: "header",
      event_label: item,
      event_action: "desktop_header_item_clicked",
      value: 1,
    });
  };

  return (
    <header className={`header ${isScrolled ? "header--scrolled" : ""}`}>
      <div className="header__content">
        <img src={Logo} alt="Logo da Provenduz" className="header__logo" />
        <img src={SymbolLogo} alt="Logo da Provenduz" className="header__logo_mobile" />

        <nav className="header__menu">
          <ul>
            <li className="header__menu--item">
              <a href="/#" onClick={() => handleClickItem("home")}>
                Início
              </a>
            </li>
            <li className="header__menu--item">
              <a href="/#plans" onClick={() => handleClickItem("plans")}>
                Planos
              </a>
            </li>
            <li className="header__menu--item">
              <a
                href="https://linktr.ee/provenduz"
                target="_blank"
                onClick={() => handleClickItem("contact")}
              >
                Contato
              </a>
            </li>
          </ul>

          {import.meta.env.URL_PORTAL && (
            <Button size="small" theme="primary" onClick={() => {
              handleClickItem('login')

              const URL = import.meta.env.URL_PORTAL
              if (URL)
                window.open(URL, "_blank")
            }}>
              Entrar
            </Button>
          )}
        </nav>

        <div className="header__mobile-menu">
          <i className="bx bx-menu" onClick={handleClickMobileMenu}></i>
        </div>
      </div>

      {isMobileMenuOpen && <MobileMenu onClose={handleClosekMobileMenu} />}
    </header>
  );
};
